import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const DentistryIcon = React.memo(({ width = 81, height = 80, viewBox = '0 0 81 80' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={remCss(width)}
    height={remCss(height)}
    viewBox={viewBox}
  >
    <path
      d='M79.6426 40C79.6426 61.8153 61.9578 79.5 40.1426 79.5C18.3273 79.5 0.642578 61.8153 0.642578 40C0.642578 18.1848 18.3273 0.5 40.1426 0.5C61.9578 0.5 79.6426 18.1848 79.6426 40Z'
      fill={variables['colors-mc-primary']}
      fillOpacity='0.1'
      stroke={variables['colors-mc-primary']}
    />
    <g clipPath='url(#clip0_414_17344)'>
      <path
        d='M62.3935 31.3536C62.3935 32.1635 61.7366 32.8207 60.9271 32.8207H59.4604C59.4604 42.4502 59.4893 41.7746 59.3871 42.0813L56.5272 39.2203V32.8207H55.0609C54.2514 32.8207 53.5945 32.1635 53.5945 31.3536C53.5945 30.5437 54.2514 29.8865 55.0609 29.8865H56.5272V21.5582C56.5272 18.5965 53.292 17.0622 51.0592 18.7083C52.3612 20.9528 52.0534 23.8833 50.1342 25.8032L48.9432 26.9946C48.3687 27.5675 47.4406 27.5664 46.8688 26.9946L40.6466 20.7701C40.0748 20.1968 40.0748 19.2675 40.6466 18.6945C41.9383 17.4025 43.2319 15.7847 45.9861 15.7847C47.0595 15.7847 48.0891 16.0712 48.9867 16.6083C53.0807 13.1441 59.4607 15.9914 59.4607 21.5582V29.8869H60.9271C61.7366 29.8865 62.3935 30.5437 62.3935 31.3536Z'
        fill='#FFA039'
      />
      <path d='M32.8672 49.9373V56.7839H47.5324V49.9373H32.8672Z' fill='#1FC0F4' />
      <path d='M40.1997 49.9373V56.7839H47.5323V49.9373H40.1997Z' fill='#1BA6EF' />
      <path
        d='M29.9341 44.0687V48.9592C29.9341 49.769 30.591 50.4263 31.4005 50.4263H48.9988C49.8087 50.4263 50.4656 49.769 50.4656 48.9592V44.2213C50.2317 43.9879 51.7736 44.0687 29.9341 44.0687Z'
        fill='#FECB74'
      />
      <path
        d='M40.1997 44.0631V50.4264H48.9987C49.8086 50.4264 50.4654 49.7691 50.4654 48.9593V44.2214C50.2766 44.0326 51.2417 44.0494 40.1997 44.0631Z'
        fill='#FFA039'
      />
      <path
        d='M51.9319 65.0977H28.4673C27.6575 65.0977 27.001 64.4408 27.001 63.6306V61.6744C27.001 58.7081 29.4134 56.2949 32.3782 56.2949H48.0215C50.9867 56.2949 53.3987 58.7081 53.3987 61.6744V63.6306C53.3987 64.4408 52.7422 65.0977 51.9319 65.0977Z'
        fill='#FECB74'
      />
      <path
        d='M48.0214 56.2949H40.1997V65.0977H51.9322C52.7417 65.0977 53.3986 64.4404 53.3986 63.6306V61.6744C53.3986 58.7077 50.9865 56.2949 48.0214 56.2949Z'
        fill='#FFA039'
      />
      <path
        d='M63.5702 45.5749L54.1841 36.185C53.9091 35.9099 53.536 35.7551 53.1469 35.7551H38.8128L39.7905 32.8208H43.133C43.9428 32.8208 44.5993 32.1639 44.5993 31.3537C44.5993 30.5434 43.9428 29.8865 43.133 29.8865C42.2007 29.8865 35.2648 29.8865 34.3336 29.8865C33.5237 29.8865 32.8672 30.5434 32.8672 31.3537C32.8672 32.1639 33.5237 32.8208 34.3336 32.8208H36.6987L35.721 35.7551H29.7342L24.8415 29.0034C23.1008 26.6021 19.7321 26.065 17.3315 27.806L15.7484 28.9542C15.0926 29.4295 14.9465 30.347 15.4218 31.0031L24.806 43.9521C25.0822 44.3328 25.5236 44.5579 25.9935 44.5579H50.1097L60.1133 54.5657C60.6859 55.1387 61.6148 55.1387 62.1874 54.5657L63.5702 53.1825C65.6668 51.0848 65.6668 47.6722 63.5702 45.5749Z'
        fill='#1FC0F4'
      />
      <path
        d='M43.1328 32.8207H40.1997V29.8865H43.1328C43.9423 29.8865 44.5992 30.5437 44.5992 31.3536C44.5992 32.1635 43.9423 32.8207 43.1328 32.8207Z'
        fill='#1BA6EF'
      />
      <path
        d='M63.5705 53.1826L62.1869 54.5658C61.615 55.1388 60.6862 55.1388 60.1132 54.5658L50.1095 44.5579H40.1997V35.7551H53.1472C53.5363 35.7551 53.909 35.9096 54.1836 36.1847L63.5705 45.5753C65.6666 47.6722 65.6666 51.0849 63.5705 53.1826Z'
        fill='#1BA6EF'
      />
    </g>
    <defs>
      <clipPath id='clip0_414_17344'>
        <rect width='50' height='50' fill='white' transform='translate(15.1426 15)' />
      </clipPath>
    </defs>
  </svg>
));
DentistryIcon.displayName = 'DentistryIcon';

export default DentistryIcon;
